module.exports = __webpack_public_path__ + "img/火币中国大图2.e019a734.jpeg";